import { Box, Card, Divider, Stack, Typography } from "@mui/material";
import { Dimension } from "../../types";
import { useTranslation } from "../../../../hooks/useTranslation";

type Props = {
  dimensions: {
    length?: Dimension;
    width?: Dimension;
    height?: Dimension;
    weight?: Dimension;
  };
  totalDesi?: number;
  estimatedCost?: number;
};

export const PackageInfoCard = ({
  dimensions,
  totalDesi,
  estimatedCost,
}: Props) => {
  const { translate } = useTranslation("pages.orderDetails");

  return (
    <Card
      elevation={0}
      sx={{
        p: 2,
        backgroundColor: (theme) => theme.palette.customBackground.box,
        borderLeft: "3px solid",
        borderColor: "primary.main",
      }}
    >
      <Typography variant="subtitle1" fontWeight={500}>
        {translate("packageInfo.title")}
      </Typography>
      <Divider sx={{ my: 1 }} />
      <Stack spacing={1}>
        <Box display="flex">
          <Box width={140}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.dimensions")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {dimensions.length?.value} x {dimensions.width?.value} x{" "}
            {dimensions.height?.value} {dimensions.height?.unit}
          </Typography>
        </Box>

        <Box display="flex">
          <Box width={140}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.weight")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {dimensions.weight?.value} {dimensions.weight?.unit}
          </Typography>
        </Box>

        <Box display="flex">
          <Box width={140}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.desi")}
            </Typography>
          </Box>
          <Typography variant="body2">{totalDesi}</Typography>
        </Box>
        <Box display="flex">
          <Box width={140}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.warehouseCost")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {estimatedCost && `${estimatedCost} $`}
          </Typography>
        </Box>
      </Stack>
    </Card>
  );
};
